class Line {
  constructor(k, b, isCorrected = false) {
    this.a = k;
    this.b = b;
    this.isCorrected = isCorrected;
  }
}

class Point {
  constructor(x, y) {
    this.x = x;
    this.y = y;
  }
}

// Main GetLine function
function getLine(projectCode, deviceId, statusType) {
  if (!projectCode || !projectCode.trim() || 
      !deviceId || !deviceId.trim() || 
      !statusType || !statusType.trim()) {
    return new Line(1, 0, false);
  }

  const list = getDataSampleList(projectCode, deviceId, statusType);
  if (!list || list.length === 0) {
    return new Line(1, 0, false);
  }

  let k = 1;
  let b = 0;
  
  if (list.length === 1) {
    return new Line(k, list[0].correctionValue - list[0].value, true);
  }

  if (list.length === 2) {
    const item1 = list[0];
    const item2 = list[1];
    
    if (item1.value === item2.value) {
      const avgCorrection = list.reduce((sum, item) => sum + item.correctionValue, 0) / list.length;
      b = avgCorrection - item1.value;
    } else {
      k = (item2.correctionValue - item1.correctionValue) / (item2.value - item1.value);
      b = item1.correctionValue - k * item1.value;
    }
    
    return new Line(Math.round(k * 100) / 100, Math.round(b * 100) / 100, true);
  }

  const points = list.map(item => new Point(item.value, item.correctionValue));
  const line = linearRegressionSolve(points);
  line.k = Math.round(line.k * 100) / 100;
  line.b = Math.round(line.b * 100) / 100;
  line.isCorrected = true;
  
  return line;
}

function linearRegressionSolveTwoPoints(pointsList) {
  const item1 = pointsList[0];
  const item2 = pointsList[1];
  const a = (item2.y - item1.y) / (item2.x - item1.x);
  const b = item1.y - a * item1.x;

  return new Line(a, b);
}

function linearRegressionSolve(pointsList) {
  if (pointsList.length === 2) {
    
    return linearRegressionSolveTwoPoints(pointsList);
  }

  let sumX = 0, sumY = 0;
  let avgX = 0, avgY = 0;

  // Calculate sums
  for (const point of pointsList) {
    sumX += point.x;
    sumY += point.y;
  }
  
  avgX = sumX / pointsList.length;
  avgY = sumY / pointsList.length;

  // Calculate sumA = Σ(x-avgX)(y-avgY) and sumB = Σ(x-avgX)²
  let sumA = 0, sumB = 0;
  for (const point of pointsList) {
    sumA += (point.x - avgX) * (point.y - avgY);
    sumB += Math.pow(point.x - avgX, 2);
  }
  
  let k = sumB !== 0 ? sumA / sumB : 1;
  let b = avgY - k * avgX;

  return new Line(k, b);
}

// Helper function to get data sample list (you need to implement this based on your data source)
function getDataSampleList(projectCode, deviceId, statusType) {
  // This function needs to be implemented based on your data structure
  // Return an array of objects with 'value' and 'correctionValue' properties
  // Example return: [{ value: 10, correctionValue: 12 }, { value: 20, correctionValue: 22 }]
  return [];
}

export { Line, linearRegressionSolve, Point };